import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiRequest from "./AxiosConfiguration";

const initialState = {
  current: null,
  loading: false,
  saving: false,
  error: null,
  existsPending: false,
};

export const fetchShiftChangeOverForCreate = createAsyncThunk(
  "shiftChangeOver/fetchForCreate",
  async ({ shiftChangeOverId = 0, facilityId, employeeId, savedDate, companyId }) => {
    const response = await apiRequest(
      "GET",
      `ShiftChangeOver/GetShiftChangeOverCreate?shiftChangeOverId=${shiftChangeOverId}&facilityId=${facilityId}&employeeId=${employeeId}&savedDate=${savedDate}&companyId=${companyId}`,
    );
    return response.data;
  },
);

export const fetchShiftChangeOverById = createAsyncThunk(
  "shiftChangeOver/fetchById",
  async ({ id, companyId }) => {
    const response = await apiRequest(
      "GET",
      `ShiftChangeOver/GetShiftChangeOverById?shiftChangeOverId=${id}&companyId=${companyId}`,
    );
    return response.data;
  },
);

export const checkShiftChangeOver = createAsyncThunk(
  "shiftChangeOver/check",
  async ({ facilityId, companyId }) => {
    const response = await apiRequest(
      "GET",
      `ShiftChangeOver/Checkshiftchangeover?facilityId=${facilityId}&companyId=${companyId}`,
    );
    return response.data;
  },
);

// Single save entry point (ShiftChangeOver/ShiftChangeSave) — the backend
// branches internally between Update (ShiftchangeOver_ID > 0) and
// Save+per-column now, same as SMIL-e's BAL ShiftChangeSave, instead of the
// frontend picking which of two endpoints to call.
export const saveShiftChangeOver = createAsyncThunk(
  "shiftChangeOver/save",
  async (model, { rejectWithValue }) => {
    const response = await apiRequest(
      "POST",
      "ShiftChangeOver/ShiftChangeSave",
      model,
      true,
    );
    if (!response.success) return rejectWithValue(response.error);
    return response.data;
  },
);

const shiftChangeOverSlice = createSlice({
  name: "shiftChangeOver",
  initialState,
  reducers: {
    clearShiftChangeOver: (state) => {
      state.current = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchShiftChangeOverForCreate.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchShiftChangeOverForCreate.fulfilled, (state, action) => {
        state.loading = false;
        state.current = action.payload;
      })
      .addCase(fetchShiftChangeOverForCreate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || "Failed to load";
      })
      .addCase(fetchShiftChangeOverById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchShiftChangeOverById.fulfilled, (state, action) => {
        state.loading = false;
        state.current = action.payload;
      })
      .addCase(fetchShiftChangeOverById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || "Failed to load";
      })
      .addCase(checkShiftChangeOver.fulfilled, (state, action) => {
        state.existsPending = action.payload > 0;
      })
      .addCase(saveShiftChangeOver.pending, (state) => {
        state.saving = true;
      })
      .addCase(saveShiftChangeOver.fulfilled, (state) => {
        state.saving = false;
      })
      .addCase(saveShiftChangeOver.rejected, (state, action) => {
        state.saving = false;
        state.error = action.payload || "Failed to save";
      });
  },
});

export const { clearShiftChangeOver } = shiftChangeOverSlice.actions;
export default shiftChangeOverSlice.reducer;